var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "p",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading",
          },
        ],
      },
      [_vm._v("Loading...")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.posts,
            expression: "posts",
          },
        ],
      },
      [
        _c(
          "div",
          { staticClass: "grid-x grid-margin-x grid-margin-y" },
          _vm._l(_vm.posts, function (post) {
            return _c(
              "div",
              {
                staticClass:
                  "small-12 medium-6 large-4 cell grid-x align-stretch",
              },
              [_c("single-post-component", { attrs: { post: post } })],
              1
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }